import { jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useBaseActionGlobalHandlers, useAssignGlobalHandler, useLabelGlobalHandler, useSetItemsStarredGlobalHandler } from "@sprout/client-components";
import { useMemo } from "react";
import { isNotNull } from "sprout-lib";
export default function useTopicPageViewsTopicGlobalHandlers({ topic  }) {
    const { rootTopicOrSelf  } = topic;
    const { members  } = rootTopicOrSelf !== null && rootTopicOrSelf !== void 0 ? rootTopicOrSelf : {};
    const postNodes = topic.posts.nodes;
    const sectionNodes = topic.sections.nodes;
    const labelNodes = rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.labels.nodes;
    /**
   * The reason why this is needed is so that the `LabelsDialog` can render
   * the correct label states of the leaves.
   *
   * If we were to pass the items directly from `setState` into `LabelsDialog`,
   * the items would be "stale" after each mutation.
   */ const posts = useMemo(()=>{
        return [
            ...postNodes,
            ...sectionNodes.flatMap((section)=>section.posts.nodes), 
        ];
    }, [
        postNodes,
        sectionNodes
    ]);
    const dialogsToRender = useBaseActionGlobalHandlers({
        posts,
        sections: sectionNodes
    });
    const labelDialog = useLabelGlobalHandler({
        items: posts,
        labels: labelNodes !== null && labelNodes !== void 0 ? labelNodes : [],
        rootTopicId: rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.id
    });
    const workspaceMembers = useMemo(()=>{
        return ((members === null || members === void 0 ? void 0 : members.nodes) || []).map((topicMember)=>topicMember.user).filter(isNotNull);
    }, [
        members === null || members === void 0 ? void 0 : members.nodes
    ]);
    const assignmentDialog = useAssignGlobalHandler({
        items: posts,
        workspaceMembers
    });
    useSetItemsStarredGlobalHandler();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            dialogsToRender,
            labelDialog,
            assignmentDialog
        ]
    });
};
